import { ReactComponent as SearchIcon } from "../../../assets/icons/regular/search.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/regular/close.svg";
import { ReactComponent as BarsFiltersIcon } from "../../../assets/icons/regular/bars_filters.svg";
import { Container, SearchButton, FiltersButton, Badge } from "./Search.styles";
import { Filters } from "../dialogs/Filters";
import { useSearch } from "./Search.hooks";
import { Avatar, Button, Drawer } from "@pinkyhead/dovekit";
import { User } from "./User";


export const Search = () => {
  const {
    openFiltersModal,
    setOpenFiltersModal,
    searchValue,
    setSearchValue,
    handleSearch,
    handleKeyPress,
    filtersExists,
    isMobile,
  } = useSearch();
  return (
    <Container>
      <div className="input-container">
        <input 
          placeholder="Search something..."
          onChange={(event) => setSearchValue(event.target.value)}
          value={searchValue}
          onKeyDown={(event) => handleKeyPress(event)}
        />
        {searchValue &&
          <button className="clear" onClick={() => {
            handleSearch("");
          }}>
            <CloseIcon />
          </button>
        }
        <SearchButton onClick={() => handleSearch(searchValue)}>
          <SearchIcon />
        </SearchButton>
      </div>
      {!isMobile &&
        <FiltersButton onClick={() => setOpenFiltersModal(true)}>
          <BarsFiltersIcon />
            {filtersExists &&
              <Badge />
            }
        </FiltersButton>
      }
      {isMobile &&
        <User />  
      }
      {openFiltersModal &&
        <Filters
          open={openFiltersModal}
          setOpen={setOpenFiltersModal}
        />
      }
    </Container>
  )
}
